// eslint-disable-next-line no-unused-vars
import styled, { css } from 'styled-components/macro';

export const Banner = styled.div`
  gap: 15px;
  position: relative;
  color: var(--primary-text-color);
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 1;

  .btn {
    position: absolute;
    top: 15px;
    right: 15px;
  }
`;

export const TextBox = styled.div`
  position: relative;
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  margin-bottom: 22px;
`;
export const Title = styled.div`
  display: block;
  font-size: 24px;
  line-height: 28px;
  font-weight: 600;
  margin: 0 0 10px;
  position: relative;
`;

export const InputFile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  width: 100%;
  height: 300px;
  margin: 0 auto 30px;
  color: var(--primary-text-color);
  cursor: pointer;
  border: 1px dashed rgba(74, 85, 104, 0.25);
  border-radius: 16px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  .uploadFile {
    display: none;
  }

  ${({ $bg }) =>
    $bg &&
    css`
      background-image: url(bg);
    `}
`;

export const Label = styled.label`
  cursor: pointer;
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
  color: var(--white);
  ${({ isFile }) =>
    !isFile &&
    css`
      color: var(--black);
    `}
  span {
    display: flex;
    justify-content: center;
    align-items: center;
    text-shadow: 0 0 10px rgb(0, 0, 0, 0.9);
  }
`;
export const BtnHolder = styled.div`
  text-align: center;
`;
